import {
    SET_CART_QUANTITY,
    INIT_CART,
    ADD_CART_ITEM,
    UPDATE_CART_ITEM,
    REMOVE_CART_ITEM,
} from "../actions/types";
    
const INITIAL_STATE = {
    carts: [],
    cartQuantity: 0,
};

export default function (state = INITIAL_STATE, action)  {
    switch (action.type) {
        case SET_CART_QUANTITY:
            return { ...state, cartQuantity: action.payload };
        case INIT_CART:
            return { ...state, carts: action.payload };
        case ADD_CART_ITEM:
            return { ...state, carts: action.payload };
        case UPDATE_CART_ITEM:
            return { ...state, carts: action.payload };
        case REMOVE_CART_ITEM:
            return { ...state, carts: action.payload };
        default:
            return state;
    }
}